/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-25 14:12:02
 * @LastEditTime: 2024-03-11 16:34:10
 * @Descripttion: file content
 */

import api from '@/api'
import {takeEvery, call, put} from 'redux-saga/effects'
import {commAction, homeworkAction, userAction} from '../action'
import {AppModule} from '@/types/api'
import {persistor} from '@/redux'
export default function* listenSaga() {
	yield takeEvery(commAction.GET_APP_CONF_MODULE, function* () {
		try {
			const res = (yield call(api.getAppConfModule)) as AppModule[]

			yield put({type: commAction.UPDATE_APP_CONF_MODULE, payload: res})
		} catch (error) {
			// 处理错误逻辑
			yield put({type: commAction.SET_TOKEN, payload: ''})
			persistor.purge()
			yield put({type: commAction.RESET_COMM_STORE})
			yield put({type: homeworkAction.RESET_HOMEWORK_STORE})
			yield put({type: userAction.RESET_USER_STORE})
		}
	})
}
